import { render, staticRenderFns } from "./ErrorLanding.vue?vue&type=template&id=88be0418&scoped=true&"
import script from "./ErrorLanding.vue?vue&type=script&lang=js&"
export * from "./ErrorLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88be0418",
  null
  
)

component.options.__file = "ErrorLanding.vue"
export default component.exports